export default __webpack_public_path__ + "static/media/calendar.c966dfcf.svg";